	<template>
		<div class="main_section">
			<div class="title mb-5">
				<h2>{{ $t('Checkin') }}</h2>
			</div>

			<div v-if="reservations.length == 0">
				<vx-card>
					<p align="center">{{ $t('noCheckin') }}</p>
				</vx-card>
			</div>

			<div v-if="reservations.length > 0">
				<div v-if="current_reservation == ''">
					<div class="p-2">
						<div class="flex flex-wrap">
							<div class="sm:w-full lg:w-1/3 p-2" v-for="(r, index) in reservations" :key="index">
								<vx-card class="w-full">
									<h5 align="center">{{ $t('reservation') }} Nº {{ r.num_reserva }}</h5>
									<p align="center" class="text-grey">{{ r.hvg_desc }}</p>
									<div class="w-full">
										<div class="flex flex-wrap">
											<div class="w-1/2 p-2">
												<div class="w-full">
													<h5 align="center">{{ formateDate(r.current_data_check_in) }}</h5>
													<p align="center" class="text-grey">Check-in</p>
												</div>
											</div>

											<div class="w-1/2 p-2">
												<div class="w-full">
													<h5 align="center">{{ formateDate(r.current_data_check_out) }}</h5>
													<p align="center" class="text-grey">Check-out</p>
												</div>
											</div>
										</div>
									</div>
									<vs-button class="w-full" v-on:click="openReservation(r)">{{ $t('open') }}</vs-button>
								</vx-card>
							</div>
						</div>
					</div>
				</div>
				<div v-if="current_reservation != ''">
					<vs-button class="mb-5" color="primary" type="filled" v-on:click="goBack()">{{ $t('returnButton') }}</vs-button>
					<iframe :src="current_reservation.url + '&lang=' + languages[$i18n.locale]" style="width: 100%; height: 800px; margin: 0; border: none" frameborder="0" ></iframe>
				</div>
			</div>
		</div>
	</template>

<script>
import moment from 'moment';

export default {
	data() {
		return {
			reservations: false,
			current_reservation: '',
			languages: {pt:'1', br:'1', en:'2', de:'3', es:'4', fr:'5'}
		}
	},
	methods: {
		formateDate(date) {
			moment.locale('pt');
			let new_date = moment(date).format('L');
			/* Don't ask me why, i had to repeat the replace so it would replace both '/' for '-' on the date */
 			new_date = new_date.replace('/', '-');
			new_date = new_date.replace('/', '-');	
            return new_date; 
        },

		getReservations() {
			this.$vs.loading();
            let token = localStorage.getItem('usertoken');
			let user = JSON.parse(window.localStorage.getItem('userSession'));
			let self = this;

            this.$api({
                method: 'get',
                url: '/myvilagale/user/reservations/' + user.id,
                params: {
                    token: token,
                    id: user.id
                },
                headers: {
                    Authorization: 'Bearer ' + token
                }
            })
            .then(function (res) {
				self.$vs.loading.close();
				self.reservations = res.data;
				self.current_reservation = '';
            })
            .catch( function (err) {
				self.$vs.loading.close();
            });
		},

		openReservation(reservation) {
			this.current_reservation = reservation;
		},

		goBack() {
			this.getReservations();
		}
	},

	created() {
		this.getReservations();
	},
}
</script>

<style>
	iframe{
		overflow: hidden !important;
	}
</style>
